import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';


interface IConfirmRunDialog {
  isOpen: boolean;
  title: string;
  storeCount: number;
  itemCount: number;
  brand: string;
  isDryRun: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * A last look before a run starts: how many prices, how many stores, and what the brand filter
 * narrows it to.
 *
 * DesignedConfirmDialog is not reused here because it hard codes Yes/No buttons - a dialog that
 * writes prices to live stores should say "Apply prices" on the button that does it.
 */
const ConfirmRunDialog = ({
  isOpen,
  title,
  storeCount,
  itemCount,
  brand,
  isDryRun,
  onCancel,
  onConfirm
}: IConfirmRunDialog) => {
  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <p>
          This will {isDryRun ? 'preview' : 'apply'} <b>{itemCount}</b> price
          {itemCount === 1 ? '' : 's'} across <b>{storeCount}</b> store
          {storeCount === 1 ? '' : 's'}.
        </p>
        {brand
          ? <p>Only products whose name contains <b>{brand}</b> will be {isDryRun ? 'checked' : 'touched'}.</p>
          : (
            <p className={isDryRun ? 'text-13 text-muted' : 'text-warning'}>
              {isDryRun
                ? 'No brand filter is set, so every SKU in the CSV is checked in every store you selected. Nothing is written - a preview only reports what a real run would do.'
                : (
                  <>
                    <b>No brand filter is set.</b> Every SKU in the CSV will be updated in every
                    store you selected.
                  </>
                )
              }
            </p>
          )
        }
        {!isDryRun &&
          <p className="text-13 text-muted">
            A price lower than the current one is always refused.
          </p>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button color="primary" variant="contained" onClick={onConfirm}>
          {isDryRun ? 'Run preview' : 'Apply prices'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ConfirmRunDialog);
